// extracted by mini-css-extract-plugin
export default {"divCardsBlog":"AdminBlog_divCardsBlog__96U2X"};